export enum NotificationStackId {
  BOTTOM_CENTER = "bottom-center",
  NEXT_SLIDE = "next-slide",
  TOP_CENTER = "top-center",
  OVERLAY = "overlay",
}

export type NotificationStack = {
  id: NotificationStackId;
  position: string;
};

export const NOTIFICATION_STACKS: Record<
  NotificationStackId,
  NotificationStack
> = {
  [NotificationStackId.BOTTOM_CENTER]: {
    id: NotificationStackId.BOTTOM_CENTER,
    position:
      "fixed bottom-16 left-1/2 transform -translate-x-1/2 z-[300] flex flex-col gap-2 max-h-[calc(100vh-4rem)]",
  },
  [NotificationStackId.NEXT_SLIDE]: {
    id: NotificationStackId.NEXT_SLIDE,
    position:
      "fixed bottom-48 right-0 z-50 flex flex-col gap-2 max-h-[calc(100vh-4rem)]",
  },
  [NotificationStackId.TOP_CENTER]: {
    id: NotificationStackId.TOP_CENTER,
    position:
      "fixed top-2 left-1/2 transform -translate-x-1/2 z-[5000] flex flex-col gap-2 max-h-[calc(100vh-4rem)] pointer-events-none",
  },
  [NotificationStackId.OVERLAY]: {
    id: NotificationStackId.OVERLAY,
    position: "flex flex-col gap-2",
  },
};

/**
 * Copy and timing of toasts the dev overlay's gallery also shows, so the
 * gallery cannot drift from the product. Each caller shows them itself: the
 * product's next-bite toast takes the slide-change lock, the gallery's not.
 */
export const LOCKED_TOAST = {
  title: (label: string) => `Locked for ${label}`,
  subheading: "Hang on, we're not done with this bite yet.",
  durationMs: 5000,
};

export const NEXT_BITE_TOAST = {
  titleTemplate: "Next bite coming up in {{seconds}}",
  subheading: "If you have a question, ask the tutor to pause.",
  durationMs: 3000,
};

export const CHAT_REFUSED_TOAST = {
  message: "Couldn't send that just yet — try again in a moment.",
  durationMs: 4000,
};
